import { render, staticRenderFns } from "./MemberActivityDetails.vue?vue&type=template&id=5457591e&scoped=true"
import script from "./MemberActivityDetails.vue?vue&type=script&lang=js"
export * from "./MemberActivityDetails.vue?vue&type=script&lang=js"
import style0 from "./MemberActivityDetails.vue?vue&type=style&index=0&id=5457591e&prod&scoped=true&lang=css"
import style1 from "./MemberActivityDetails.vue?vue&type=style&index=1&id=5457591e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457591e",
  null
  
)

export default component.exports